import { stringify } from 'hub-http/helpers/params';
export const addParamsToLink = (baseLink, queryParams) => {
  if (!baseLink) {
    return undefined;
  }
  const queryString = stringify(queryParams);
  if (!queryString) {
    return baseLink;
  }
  if (baseLink.includes('?')) {
    return `${baseLink}&${queryString}`;
  }
  return `${baseLink}?${queryString}`;
};
export const addHandholdingBannerParamsToLink = (baseLink, handholdingBanner) => {
  if (!baseLink || !handholdingBanner) {
    return baseLink;
  }
  return addParamsToLink(baseLink, {
    onboarding_referrer_task: handholdingBanner.taskId.toString(),
    onboarding_referrer_group: handholdingBanner.taskGroupKey,
    onboarding_referrer_source: handholdingBanner.taskSource
  });
};